import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../BioBest/bioBest.css";
import BioBestimg from "../../images/BioBest_img.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import { FaRegClosedCaptioning } from "react-icons/fa";
// import { jsPDF } from "jspdf";

const BioBest = () => {
  const location = useLocation();

  const Relocation_Id = location.state?.Relocation_Id; // Get Relocation_Id from route state

  const downloadPDF = () => {
    const input = document.getElementById("pdf-content");

    html2canvas(input, {
      scale: 3, // Increase the scale for higher resolution
      useCORS: true, // Ensure cross-origin images are rendered
      backgroundColor: "#ffffff", // Explicitly set background to white to avoid transparency issues
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0); // Use 1.0 for best quality
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = 210; // 210 mm
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("BioBest.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchRows = async () => {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (!Relocation_Id) {
          console.error("Relocation_ID is not defined");
          alert("Relocation_ID is not available. Please check the data.");
          return;
        }

        const response = await axios.get(
          `${baseAPI}userget/GetBioBestForm?relocation_id=${Relocation_Id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        // if (response.data.status === "True") {
        //   const bioBestForm = response.data.data?.BioBestForm?.[0] || {};
        //   const rabiesVaccination = response.data.data?.RabiesVaccination || [];
  
        //   console.log("BioBestForm:", bioBestForm);
        //   console.log("RabiesVaccination:", rabiesVaccination);
  
        //   setBioFormData((prevData) => ({
        //     ...prevData,
        //     ...bioBestForm,
        //   }));
  
        //   setVaccineData(rabiesVaccination); // Setting vaccine data properly

        if (
          response.data.status === "True" &&
          response.data.data?.BioBestForm?.length > 0
        ) {
          console.log(response.data.data[0]); // Debugging API response

          setBioFormData((prevData) => ({
            ...prevData,
            ...response.data.data.BioBestForm[0], // Correctly mapping the first object in "data" array
          }));
        } else {
          console.warn("No data found for this Relocation_Id");
        }
      } catch (error) {
        console.error("Error fetching rows data:", error);
      }
    };

    fetchRows();
  }, [Relocation_Id, baseAPI]);

  const [error, setError] = useState("");

  const [isEditing, setIsEditing] = useState(false);

  const [bioFormData, setBioFormData] = useState({
    relocation_id: Relocation_Id,
    biobest_name: "",
    bioBest_postcode_address: "",
    biobest_veterinary_practice: "",
    biobest_telephone: "",
    biobest_signature: "",
    biobest_name_block: "",
    biobest_date: "",
    biobest_email: "",
    biobest_date_birth: "",
    biobest_microchip_number: "",
    biobest_avid_microchip: "",
    biobest_date_blood_microchip: "",
    biobest_cat: "",
    biobest_dog: "",
    biobest_animal_name: "",
  });

  const [vaccineData, setVaccineData] = useState([
    { owner_table_date: "", biobest_Vaccine: "", biobest_batch_number: "" },
    { owner_table_date: "", biobest_Vaccine: "", biobest_batch_number: "" },
    { owner_table_date: "", biobest_Vaccine: "", biobest_batch_number: "" },
  ]);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    if (type === "checkbox") {
      // If checkbox is checked, set value to 1, otherwise set it to 0
      setBioFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value, // ✅ Ensure checkbox values are boolean
      }));
    } else {
      // For other input types, handle normally
      setBioFormData({
        ...bioFormData,
        [name]: value,
      });
    }
  };

  // data send
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      biodata: bioFormData,
      vaccinList: vaccineData,
    };
    console.log(vaccineData);
    console.log(bioFormData);
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}UserPost/BioBestFrom`,
        payload, // Send the payload (as JSON)
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json", // JSON content type for a regular API call
          },
        }
      );
      setBioFormData({
        biobest_name: "",
        bioBest_postcode_address: "",
        biobest_veterinary_practice: "",
        biobest_telephone: "",
        biobest_signature: "",
        biobest_name_block: "",
        biobest_date: "",
        biobest_email: "",
        biobest_date_birth: "",
        biobest_microchip_number: "",
        biobest_avid_microchip: "",
        biobest_date_blood_microchip: "",
        biobest_cat: "",
        biobest_dog: "",
        biobest_animal_name: "",
        owner_table_date: "",
        biobest_Vaccine: "",
        biobest_batch_number: "",
        createdBy: "",
      });
      if (response.data.status === "True") {
        alert("Practice information submitted successfully!");
      } else {
        alert(`Submission failed: ${response.data.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(
        `An error occurred while submitting the form. Please try again.\nError: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };
  return (
    <>
      <div className="a4-form" id="pdf-content">
        <div>
          <div className="bio_logo-container">
            <h1 className="bioBist_h1">RABIES SEROLOGY CERTIFICATE</h1>
            <div>
              <img src={BioBestimg} alt="Biobest Logo" />
            </div>
          </div>
        </div>

        <section
          className="instructions bioBest_section"
          style={{ padding: "8px 19px 0px 19px" }}
        >
          <div className="row">
            <div className="col-6">
              <h3 className="bioBist_h3">SAMPLING INSTRUCTIONS:</h3>
              <ul className="bioBist_ui">
                <li>PLEASE COMPLETE ONE SUBMISSION FORM PER ANIMAL</li>
                <li>
                  SEND A MINIMUM OF 1ML SERUM (PREFERABLE) OR 2ML CLOTTED BLOOD
                </li>
                <li>
                  CLEARLY LABEL SAMPLE WITH THE ANIMAL’S NAME AND MICROCHIP
                  NUMBER
                </li>
                <li>SAMPLES WILL BE TESTED BY BIOBEST LABORATORIES LTD</li>
              </ul>
            </div>
            <div className="col-6">
              <h3 className="bioBist_h3">REPORTING INFORMATION:</h3>
              <ul className="bioBist_ui">
                <li>
                  YOUR COMPLETED RABIES CERTIFICATE WILL BE POSTED. AN E-MAIL
                  COPY IS AVAILABLE ON REQUEST
                </li>
                <li>
                  FOR THE PURPOSES OF THE UK PET TRAVEL SCHEME A TEST TITRE OF
                  0.5IU/ML OR ABOVE INDICATES THAT THE DOG OR CAT HAS AN
                  ACCEPTABLE RABIES ANTIBODY LEVEL
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="owner-details bioBest_section">
          <div className="row">
            <div className="col-6" style={{ paddingRight: "30px" }}>
              <h3 className="bioBist_h3">OWNER’S DETAILS:</h3>
              <label
                className="bioBist_label"
                style={{ fontWeight: "400", paddingBottom: "6px" }}
              >
                Name:
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_name"
                  value={bioFormData.biobest_name}
                  onChange={handleChange}
                  type="text"
                />
              ) : (
                <div className="bioBest_input">{bioFormData.biobest_name}</div>
              )}
            </div>
            <div className="col-6" style={{ paddingRight: "38px" }}>
              <label
                className="bioBist_label"
                style={{
                  marginTop: "-2px",
                  fontWeight: "400",
                  paddingBottom: "6px",
                }}
              >
                Address And Postcode (OPTIONAL):
              </label>
              {isEditing ? (
                <textarea
                  className="titer-pvalue"
                  name="bioBest_postcode_address"
                  value={bioFormData.bioBest_postcode_address}
                  onChange={handleChange}
                  style={{
                    minHeight: "81px",
                    width: "99.5%",
                    border: "1px solid black",
                    padding: "2px",
                    marginTop: "5px",
                    fontSize: "10.6px",
                    lineHeight: "1",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                />
              ) : (
                <div
                  className="titer-pvalue"
                  style={{
                    minHeight: "81px",
                    width: "99.5%",
                    border: "1px solid black",
                    padding: "2px",
                    marginTop: "5px",
                    fontSize: "10.6px",
                    lineHeight: "1",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {bioFormData.bioBest_postcode_address}
                </div>
              )}
            </div>
          </div>
        </section>

        <section
          className="vet-details bioBest_section"
          style={{ padding: "6px 38px 10px 15px" }}
        >
          <div className="row">
            <div className="col-6">
              <h3 className="bioBist_h3" style={{ margin: "0px" }}>
                SUBMITTING VETERINARY SURGEON’S DETAILS
              </h3>
              <label
                className="bioBist_label"
                style={{ margin: "5px 0 7px 0", fontWeight: "100" }}
              >
                Veterinary Practice Name, Address And Postcode:
              </label>
              {isEditing ? (
                <textarea
                  id="biobest_veterinary_practice"
                  className="titer-pvalue"
                  name="biobest_veterinary_practice"
                  value={bioFormData.biobest_veterinary_practice}
                  onChange={handleChange}
                  style={{
                    minHeight: "102px",
                    width: "99.5%",
                    border: "1px solid black",
                    padding: "2px",
                    margin: "1px 1px 14px 1px",
                    fontSize: "14px",
                    lineHeight: "1",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                />
              ) : (
                <div
                  className="titer-pvalue"
                  style={{
                    minHeight: "102px",
                    width: "99.5%",
                    border: "1px solid black",
                    padding: "2px",
                    margin: "1px 1px 14px 1px",
                    fontSize: "14px",
                    lineHeight: "1",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {bioFormData.biobest_veterinary_practice}
                </div>
              )}
              <label
                className="bioBist_label"
                style={{ marginBottom: "7px", fontWeight: "100" }}
              >
                Telephone:
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_telephone"
                  value={bioFormData.biobest_telephone}
                  onChange={handleChange}
                  type="text"
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_telephone}
                </div>
              )}
            </div>

            <div className="col-6">
              <label
                className="bioBist_label"
                style={{
                  margin: "0 0 6px 0",
                  fontWeight: "100",
                  color: "black",
                }}
              >
                Signature of submitting veterinary surgeon*: (blue ink prefered)
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_signature"
                  value={bioFormData.biobest_signature || ""}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter signature..."
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_signature || (
                    <i>No signature provided</i>
                  )}
                </div>
              )}
              <label
                className="bioBist_label"
                style={{
                  margin: "6px 0 5px 0",
                  fontWeight: "100",
                  color: "black",
                }}
              >
                Name in BLOCK CAPITALS:
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_name_block"
                  value={bioFormData.biobest_name_block}
                  onChange={handleChange}
                  type="text"
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_name_block}
                </div>
              )}
              <label
                className="bioBist_label"
                style={{
                  margin: "6px 0 5px 0",
                  fontWeight: "100",
                  color: "black",
                }}
              >
                Date: (DD-MMM-YYYY e.g. 08-Jun-2022)
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_date"
                  value={bioFormData.biobest_date}
                  onChange={handleChange}
                  type="text"
                  placeholder="DD-MMM-YYYY"
                />
              ) : (
                <div className="bioBest_input">{bioFormData.biobest_date}</div>
              )}

              <label
                className="bioBist_label"
                style={{
                  margin: "6px 0 0px 0",
                  fontWeight: "100",
                  color: "black",
                }}
              >
                E-Mail:
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_email"
                  value={bioFormData.biobest_email}
                  onChange={handleChange}
                  type="email"
                />
              ) : (
                <div className="bioBest_input">{bioFormData.biobest_email}</div>
              )}
            </div>
          </div>
        </section>

        <section
          className="vet-details bioBest_section"
          style={{ padding: "6px 38px 11px 15px", marginBottom: "2px" }}
        >
          <div className="row">
            <div className="col-6">
              <h3 className="bioBist_h3" style={{ margin: "0px" }}>
                ANIMAL’S DETAILS
              </h3>
              <label
                className="bioBist_label"
                style={{ margin: "0px 0 0px 0", fontWeight: "100" }}
              >
                Date of Birth:{" "}
                <span style={{ fontSize: "9.3px" }}>
                  (DD-MMM-YYYY e.g. 08-Jun-2022)
                </span>
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_date_birth"
                  value={bioFormData.biobest_date_birth}
                  onChange={handleChange}
                  type="text"
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_date_birth}
                </div>
              )}
              <label
                className="bioBist_label"
                style={{
                  margin: "0px 0 5px 0",
                  fontWeight: "100",
                  color: "black",
                }}
              >
                Microchip Number:
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_microchip_number"
                  value={bioFormData.biobest_microchip_number}
                  onChange={handleChange}
                  type="text"
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_microchip_number}
                </div>
              )}
              <label
                className="bioBist_label"
                style={{
                  margin: "5px 0 3px 0",
                  fontWeight: "100",
                  color: "black",
                }}
              >
                AVID Microchip Number (if applicable):
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_avid_microchip"
                  value={bioFormData.biobest_avid_microchip}
                  onChange={handleChange}
                  type="text"
                  placeholder="DD-MMM-YYYY"
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_avid_microchip}
                </div>
              )}

              <label
                className="bioBist_label"
                style={{
                  margin: "10px 0 1px 0",
                  fontWeight: "100",
                  color: "black",
                  width: "25rem",
                }}
              >
                Date of Blood Sampling & Microchip Reading:{" "}
                <span style={{ fontSize: "9.3px" }}>
                  (DD-MMM-YYYY e.g. 08-Jun-2022)
                </span>
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_date_blood_microchip"
                  value={bioFormData.biobest_date_blood_microchip}
                  onChange={handleChange}
                  type="email"
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_date_blood_microchip}
                </div>
              )}
              <div style={{ display: "flex", paddingTop: "11px" }}>
                <div style={{ display: "flex", paddingRight: "98px" }}>
                  <p style={{ fontSize: "10.6px", color: "black" }}>Cat:</p>
                  <span style={{ padding: "0 0 0 13px" }}>
                    {" "}
                    <input
                      type="checkbox"
                      name="biobest_cat"
                      className="BioBest-custom-checkbox"
                      checked={!!bioFormData.biobest_cat}
                      onChange={handleChange}
                      disabled={!isEditing} // Disable checkbox when not in edit mode
                      style={{
                        appearance: "none",
                        backgroundColor: "#fff",
                        display: "inline-block",
                        position: "relative",
                        cursor: isEditing ? "pointer" : "not-allowed",
                      }}
                    />
                  </span>{" "}
                </div>
                <div style={{ display: "flex" }}>
                  <p style={{ fontSize: "10.6px", color: "black" }}>Dog:</p>
                  <span style={{ padding: "0 0 0 13px" }}>
                    {" "}
                    <input
                      type="checkbox"
                      name="biobest_dog"
                      className="BioBest-custom-checkbox"
                      checked={!!bioFormData.biobest_dog}
                      onChange={handleChange}
                      disabled={!isEditing}
                      style={{
                        appearance: "none",
                        backgroundColor: "#ffffff",
                        display: "inline-block",
                        position: "relative",
                        cursor: isEditing ? "pointer" : "not-allowed",
                      }}
                    />
                  </span>{" "}
                </div>
              </div>
            </div>

            <div className="col-6" style={{ paddingLeft: "28px" }}>
              {/* <h3 className="bioBist_h3" style={{margin: '0px'}}>SUBMITTING VETERINARY SURGEON’S DETAILS</h3> */}
              <label
                className="bioBist_label"
                style={{ margin: "0px 0 0px 0", fontWeight: "100" }}
              >
                Animal Name:
              </label>
              {isEditing ? (
                <input
                  className="bioBest_input"
                  name="biobest_animal_name"
                  value={bioFormData.biobest_animal_name}
                  onChange={handleChange}
                  type="text"
                />
              ) : (
                <div className="bioBest_input">
                  {bioFormData.biobest_animal_name}
                </div>
              )}

              <label
                className="bioBist_label"
                style={{
                  marginBottom: "7px",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                RABIES VACCINATION DETAILS:
              </label>
              <div className="bioBest-table-container">
                <table className="vaccine-table bioBest-tdM">
                  <thead>
                    <tr>
                      <th style={{ width: "12px" }}>Date: (DDMMYY)</th>
                      <th>Vaccine:</th>
                      <th>Batch No:</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vaccineData.map((entry, index) => (
                      <tr key={index}>
                        <td>
                          <textarea
                            name={`owner_table_date${index + 1}`}
                            className="titer-pvalue"
                            value={entry.owner_table_date}
                            onChange={(e) => {
                              const updatedData = [...vaccineData];
                              updatedData[index].owner_table_date =
                                e.target.value;
                              setVaccineData(updatedData);
                            }}
                            style={textareaStyle}
                          />
                        </td>
                        <td>
                          <textarea
                            name={`biobest_Vaccine${index + 1}`}
                            className="titer-pvalue"
                            value={entry.biobest_Vaccine}
                            onChange={(e) => {
                              const updatedData = [...vaccineData];
                              updatedData[index].biobest_Vaccine =
                                e.target.value;
                              setVaccineData(updatedData);
                            }}
                            style={textareaStyle}
                          />
                        </td>
                        <td>
                          <textarea
                            name={`biobest_batch_number${index + 1}`}
                            className="titer-pvalue"
                            value={entry.biobest_batch_number}
                            onChange={(e) => {
                              const updatedData = [...vaccineData];
                              updatedData[index].biobest_batch_number =
                                e.target.value;
                              setVaccineData(updatedData);
                            }}
                            style={textareaStyle}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
        <div
          className="BioBest-p-Tage"
          style={{ padding: "0 8px 0 8px", lineHeight: "1.2" }}
        >
          <p style={{ fontSize: "8px", margin: "0" }}>
            *By signing this form you are confirming that all information on
            this form is true and correct. You confirm that the animal being
            sampled is not known to be (or suspected to be) infected with a
            pathogen which
          </p>
          <p style={{ fontSize: "8px", margin: "0" }}>
            causes a notifiable disease according to European regulations or the
            animal health regulations of the country where the animal is based.
            You are also confirming that the animal is not from a region or zone
            of a
          </p>
          <p style={{ fontSize: "8px", margin: "0", textAlign: "center" }}>
            country that is subject to official restrictions due to a notifiable
            disease to which the animal is susceptible according to European or
            other national animal health regulations.
          </p>
        </div>

        <section
          className="vet-details bioBest_section"
          style={{
            padding: "0px 0px 0px 0px",
            border: "none",
            marginBottom: "0",
          }}
        >
          <div className="row">
            <label
              className="bioBist_label"
              style={{
                marginBottom: "7px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              BIOBEST USE ONLY:
            </label>

            <div className="col-6">
              {/* <h3 className="bioBist_h3" style={{margin: '0px'}}>SUBMITTING VETERINARY SURGEON’S DETAILS</h3> */}

              <div className="bioBest-table-container">
                <table className="vaccine-table">
                  <thead>
                    <tr>
                      <th
                        style={{
                          textAlign: "left",
                          borderTop: "3px solid black",
                          borderBottom: "3px solid black",
                        }}
                      >
                        QC:
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          borderTop: "3px solid black",
                          borderBottom: "3px solid black",
                        }}
                      >
                        I:
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(1)].map((_, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "32px 0px 32px 0px",
                            width: "12rem",
                            borderBottom: "3px solid black",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginTop: "-15px",
                            }}
                          >
                            <span>Biobest No: </span>
                            <br></br>
                            <span>Date of Receipt: </span>
                          </div>
                        </td>
                        <td
                          style={{
                            borderBottom: "3px solid black",
                          }}
                        ></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-6">
              {/* <h3 className="bioBist_h3" style={{margin: '0px'}}>SUBMITTING VETERINARY SURGEON’S DETAILS</h3> */}

              <div
                id="owner_address"
                className="titer-pvalue"
                contentEditable
                // onInput={(e) => setFormData({ ...formData, owner_address: e.target.innerText })}
                style={{
                  minHeight: "137px",
                  width: "99.5%",
                  border: "1px solid black",
                  padding: "2px",
                  margin: "1px 1px 21px 1px",
                  fontSize: "14px",
                  lineHeight: "1",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {/* {formData.owner_address} */}
              </div>
            </div>

            <div
              className="BioBest-p-Tage"
              style={{ padding: "0 12px 0 12px", marginTop: "-12px" }}
            >
              <p style={{ fontSize: "10.6px", margin: "0" }}>
                Biobest Laboratories Ltd, 6 Charles Darwin House, The Edinburgh
                Technopole, Milton Bridge,Nr Penicuik, EH26 0PY Tel: 0131 440
                2628 enquiry@biobest.co.uk
              </p>
            </div>
          </div>
        </section>
      </div>
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <button onClick={toggleEdit}>{isEditing ? "Save" : "Edit"}</button>
        <button type="submit" onClick={handleSubmit}>
          Submit
        </button>
        <button style={{ marginTop: "1rem" }} onClick={downloadPDF}>
          Download as PDF
        </button>
      </div>
    </>
  );
};

const textareaStyle = {
  minHeight: "40px",
  width: "99.5%",
  border: "1px solid #ccc",
  padding: "5px",
  fontSize: "14px",
  lineHeight: "1",
  resize: "none",
};

export default BioBest;

